import { useEffect, useRef, useState } from "react";

export function useWindowSize() {
  //https://usehooks.com/useWindowSize/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}

export function useElementOnScreen(options) {
  const [isVisible, setIsVisible] = useState(false);
  const [elementRef, setElementRef] = useState(null);

  const observer = useRef(
    new window.IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      options
    )
  );

  useEffect(() => {
    const { current: currentObserver } = observer;
    currentObserver.disconnect();

    if (elementRef) currentObserver.observe(elementRef);

    return () => currentObserver.disconnect();
  }, [elementRef]);

  return [setElementRef, isVisible];
}
